import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DropdownManagerService {
  private activeDropdown: string | null = null;
  private closeDropdownSubject = new Subject<string | null>();
  
  closeDropdown$ = this.closeDropdownSubject.asObservable();

  openDropdown(dropdownId: string) {
    if (this.activeDropdown && this.activeDropdown !== dropdownId) {
      // Close the currently active dropdown
      this.closeDropdownSubject.next(this.activeDropdown);
    }
    this.activeDropdown = dropdownId;
  }

  closeDropdown(dropdownId?: string) {
    if (!dropdownId || this.activeDropdown === dropdownId) {
      this.activeDropdown = null;
      this.closeDropdownSubject.next(dropdownId || null);
    }
  }

  closeAllDropdowns() {
    if (this.activeDropdown) {
      this.closeDropdownSubject.next(this.activeDropdown);
      this.activeDropdown = null;
    }
  }
}